/* eslint-disable react/prop-types */

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faGripVertical } from "@fortawesome/free-solid-svg-icons";

const GripIcon = () => <FontAwesomeIcon icon={faGripVertical} />;

export default GripIcon;
